import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleHtmlEmbed = ({
    embed = ''
}) => {
    // misc
    const height = embed.match(/(height="(\d+)")/)?.[2];
    const width = embed.match(/(width="(\d+)")/)?.[2];

    // render
    return (
        <section className='layout-container relative my-20 md:mt-40 md:mb-60'>
            <div className='layout-grid-negative-gutter md:flex'>
                <div className='md:w-5/12 layout-grid-col-padding' />

                {embed && (
                    <div className='md:w-6/12 layout-grid-col-padding'>
                        <div
                            className={`html-embed${height && width ? ' html-embed--h-full' : ''}`}
                            dangerouslySetInnerHTML={{ __html: embed }}
                            style={{ aspectRatio: height && width ? `${width} / ${height}`: null }} />
                    </div>
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    embed: PropTypes.string.isRequired
};

ModuleHtmlEmbed.propTypes = propTypes;

export default ModuleHtmlEmbed;
